//NOTE: Initial webinar cycle config details
export const iitiansWebinarConfig = [
  { webinar1_date: '2023-03-26', cycle: 'Cycle - 100' },
];
